<template>
    <div>
        <HeadlineContainer headline="Users" :breadcrumbs="[{text: 'Users'}]">
            <router-link to="/users/create" class="btn btn-white">
                <i class="fa fa-plus"></i> Create
            </router-link>
        </HeadlineContainer>

        <div class="container">
            <UserList/>
        </div>
    </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import UserList from '../../../components/Administration/Users/Panels/List'

export default {
    components: {HeadlineContainer, UserList}
}
</script>
